import { render, staticRenderFns } from "./addfunds_installment.vue?vue&type=template&id=0e59fbc0&"
import script from "./addfunds_installment.vue?vue&type=script&lang=js&"
export * from "./addfunds_installment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports